export default "__VITE_ASSET__O9iu1wQm__"